export default {
  siteUrl: 'https://petlog.me',
  dynamicLink: 'https://petlogapp.page.link/app',
  petTagSiteUrl: 'https://tags.petlog.me',
  appScheme: 'petlog://',
};
